module.exports = __webpack_public_path__ + "assets/media/carousel_2.992d95fc.svg";